export const UPDATE_CONVERSATION_LOCATION = "CONVERSATION/UPDATE_CONVERSATION_LOCATION";
export const UPDATE_CONVERSATION_ENTITY = "CONVERSATION/UPDATE_CONVERSATION_ENTITY";
export const UPDATE_CONVERSATION_VIDEO = "CONVERSATION/UPDATE_CONVERSATION_VIDEO";
